import styled from "@emotion/styled";
import shouldForwardProp from "@styled-system/should-forward-prop";

import {
  border,
  BorderProps,
  color,
  ColorProps,
  compose,
  EmotionComponent,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  OverrideNativeElementProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from "@catchoftheday/theme";

export const listItemStyleProps = compose(
  layout,
  flexbox,
  color,
  space,
  typography,
  border
);

export type ListItemProps = OverrideNativeElementProps<
  LayoutProps &
    FlexboxProps &
    ColorProps &
    SpaceProps &
    TypographyProps &
    BorderProps,
  "li"
>;

export const ListItem: EmotionComponent<ListItemProps> = styled("li", {
  shouldForwardProp,
})`
  ${listItemStyleProps}
`;

export default ListItem;
